import { render } from "./CompleteProfilePage.vue?vue&type=template&id=08c289ca&scoped=true"
import script from "./CompleteProfilePage.vue?vue&type=script&lang=js"
export * from "./CompleteProfilePage.vue?vue&type=script&lang=js"

import "./CompleteProfilePage.vue?vue&type=style&index=0&id=08c289ca&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08c289ca"]])

export default __exports__